module.exports = __webpack_public_path__ + "img/bar-chart-fill.95f6b1e6.svg";